import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Media, MediaObject } from '@ionic-native/media/ngx';
import { StreamingMedia } from '@ionic-native/streaming-media/ngx';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
import { File, FileEntry } from '@ionic-native/file/ngx';

@Component({
  selector: 'msg-media-list',
  templateUrl: './media-list.component.html',
  styleUrls: ['./media-list.component.scss'],
})
export class MediaListComponent implements OnInit {
  @Input() files: any[];
  @Output() public deleteFile = new EventEmitter();

  win: any = window;
  audioFile: MediaObject;

  constructor(
    public media: Media,
    private streamingMedia: StreamingMedia,
    private photoViewer: PhotoViewer,
  ) {}

  ngOnInit() {}

  playAudio(f: FileEntry) {
    if (f.name.indexOf('.wav') > -1) {
      // We need to remove file:/// from the path for the audio plugin to work
      const path = f.nativeURL.replace(/^file:\/\//, '');
      this.audioFile = this.media.create(path);
      this.audioFile.play();
    } else {
      console.log(`File '${f.name}' is not an audio file, how'd we get here?`);
    }
  }

  stopAudio() {
    if (this.audioFile) {
      this.audioFile.stop();
    }
  }

  openFile(f: FileEntry) {
    if (f.name.indexOf('.mp4') > -1) {
      console.log('Use the Streaming Media plugin to play a video');
      this.streamingMedia.playVideo(f.nativeURL);
    } else if (f.name.indexOf('.jpg') > -1) {
      console.log('Use the Photoviewer to present an Image');
      this.photoViewer.show(f.nativeURL);
    }
  }

  mediaError($event, file) {
    console.log('mediaError', $event, file);
  }

  getSafeUrl(f: FileEntry) {
    const url = this.win.Ionic.WebView.convertFileSrc(f.nativeURL);
    // console.log(`image url: ${url}`);
    return url;
  }

  getPreviewUrl(f: FileEntry) {
    const url = this.win.Ionic.WebView.convertFileSrc(f.nativeURL);
    const spec = `${url.replace(/.mp4/, '')}.preview.jpg`;
    // console.log(`preview url: ${spec}`);
    return spec;
  }
}
